module.exports = __webpack_public_path__ + "static/media/thumb-neutral.8f61247e.png";